import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import { toast } from "sonner";
import { FaWhatsapp, FaApple } from "react-icons/fa";
import api from "../lib/api";
import { getTurnstileToken } from "../lib/turnstile";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [busy, setBusy] = useState(false);
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    api.get("/settings/public")
      .then((r) => setSettings(r.data))
      .catch(() => {});
  }, []);

  const phone = settings?.whatsapp || "62818404999";
  const imessage = settings?.imessage || settings?.whatsapp || "62818404999";
  const supportEmail = settings?.support_email || "support@kratoven.com";
  const msg = "Hello%20Kratoven%2C%20I%20want%20to%20inquire%20about%20your%20Borneo%20Kratom%20products...";

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const turnstile_token = await getTurnstileToken();
      await api.post("/contact", { ...form, turnstile_token });
      toast.success("Message sent. We'll reply within 24 hours.");
      setForm({ name: "", email: "", message: "" });
    } catch {
      toast.error("Failed to send. Please try WhatsApp instead.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
    <Helmet>
      <title>Contact Kratoven | Support & Orders</title>
      <meta
        name="description"
        content="Contact Kratoven support for product questions, order help, DHL shipping, and wholesale inquiries."
      />
      <link rel="canonical" href="https://kratoven.com/contact" />
    </Helmet>
    <div className="container-kv pt-32 pb-20" data-testid="contact-page">
      <div className="overline mb-4">Get in touch</div>
      <h1 className="font-serif text-4xl sm:text-5xl font-light tracking-tighter mb-12">
        We're here. <em className="italic text-[#C8A97E]">Always.</em>
      </h1>
      <div className="grid md:grid-cols-2 gap-10">
        <div>
          <div className="card-kv mb-6">
            <div className="overline mb-2">Fastest</div>
            <h3 className="font-serif text-2xl mb-4">WhatsApp & iMessage</h3>
            <p className="text-[#A8A5A1] text-sm mb-5">Direct line to our team. Reply within minutes during business hours.</p>
            <div className="flex gap-3">
              <a
                href={`https://wa.me/${phone}?text=${msg}`}
                target="_blank" rel="noopener noreferrer"
                className="btn-gold flex-1"
                data-testid="whatsapp-contact"
              ><FaWhatsapp /> WhatsApp</a>
              <a
                href={`sms:+${imessage}&body=${msg}`}
                className="btn-ghost flex-1"
                data-testid="imessage-contact"
              ><FaApple /> iMessage</a>
            </div>
          </div>
          <div className="card-kv">
            <div className="overline mb-2">Email</div>
            <a href={`mailto:${supportEmail}`} className="font-serif text-2xl hover:text-[#C8A97E]">{supportEmail}</a>
            <p className="text-[#A8A5A1] text-sm mt-3">We reply within 24 hours.</p>
          </div>
        </div>
        <form onSubmit={submit} className="card-kv space-y-4">
          <h3 className="font-serif text-2xl mb-1">Send a message</h3>
          <p className="text-xs text-[#75726D] mb-4">Protected by Cloudflare Turnstile.</p>
          <div>
            <label className="text-xs text-[#75726D] uppercase tracking-widest mb-2 block">Name</label>
            <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required data-testid="contact-name" />
          </div>
          <div>
            <label className="text-xs text-[#75726D] uppercase tracking-widest mb-2 block">Email</label>
            <input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required data-testid="contact-email" />
          </div>
          <div>
            <label className="text-xs text-[#75726D] uppercase tracking-widest mb-2 block">Message</label>
            <textarea rows={5} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} required data-testid="contact-message" />
          </div>
          <button type="submit" disabled={busy} className="btn-gold w-full" data-testid="contact-submit">
            {busy ? "Sending..." : "Send Message"}
          </button>
        </form>
      </div>
    </div>
    </>
  );
}
